import { useMemo } from "react";

import useTechnologyBreadcrumbs from "@pages/Technology/hooks/useTechnologyBreadcrumbs";
import useTechnologyViews from "@pages/Technology/hooks/useTechnologyViews";

import { OrganizationStore } from "@store/organizationStore";

const useTechnologyPageContent = () => {
  const organization = OrganizationStore.getState().organization;

  const { breadcrumbs } = useTechnologyBreadcrumbs({ isOrganization: !!organization });
  const { technologyViews, viewIndex } = useTechnologyViews({ organization });

  const technologyNavigationTabs = useMemo(
    () => technologyViews.filter((view) => view.isTab).map((view) => ({ label: view.name })),
    [technologyViews],
  );

  const currentView = useMemo(() => technologyViews[viewIndex], [technologyViews, viewIndex]);

  return {
    breadcrumbs,
    currentView,
    technologyNavigationTabs,
    technologyViews,
    viewIndex,
  };
};
export default useTechnologyPageContent;
